/**
 * @Author : zhouqinze
 * @Date : 2020-1-3
 * @Version : 1.0
 * @Content : 企业数字化转型
 **/
<template>
    <div class="chaCon">
        <div class="banner"></div>
        <div class="achieve">
            <div class="textHead">
                <h3>成就智慧企业</h3>
                <p>为企业数字化转型提供定制化的数据应用、管理运营工具及咨询服务</p>
            </div>
            <div class="topBox" ref="topBox">
                <div class="topHead">
                    <div class="traLeft">
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zh.png" alt="">
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_rh.png" alt="">
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_qd.png" alt="">
                    </div>
                    <div class="traRight">
                        <div class="rightBox" :style="{background:this.bgColorCom}">
                            <div class="rightIcon"></div>
                            <div class="rightText">转换</div>
                            <div class="rightBottom"></div>
                            <div class="rightBottomText">技术应用转换升级</div>
                        </div>
                        <div class="rightBox" :style="{background:this.bgColorCom}">
                            <div class="rightIcon"></div>
                            <div class="rightText">融合</div>
                            <div class="rightBottom"></div>
                            <div class="rightBottomText">全方位、全过程、全领域数据融合</div>
                        </div>
                        <div class="rightBox" :style="{background:this.bgColorCom}">
                            <div class="rightIcon"></div>
                            <div class="rightText">驱动</div>
                            <div class="rightBottom"></div>
                            <div class="rightBottomText">数字驱动业务，加快传统业态的变革与重构</div>
                        </div>
                    </div>
                </div>
                <div class="rightBoxBtm">
                    <div class="btmItem">
                            <div class="rightIcon"></div>
                        <div class="rightText">交通政务管理与服务的智慧化</div>
                        <div class="rightBottom"></div>
                            <div class="rightBottomText">数字化转型，成就智慧企业</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="solve">
            <div class="content">
                <div class="textHead">
                    <h3>企业数字化转型</h3>
                    <p>智能化运营，数字化创新</p>
                </div>
                <div class="solCon">
                    <div class="solItem">
                        <div class="icon"></div>
                        <h3>全渠道会员管理</h3>
                         <p>● 全渠道会员资源整合，同步消费</p>
                         <p>● 全渠道订单统一管理，高效处理</p>
                         <p>● 积分营销激活会员，引流到店</p>
                         <p>● 实现360度完善客户画像</p>
                    </div>
                    <div class="solItem">
                        <div class="icon"></div>
                        <h3>门店数字化运营</h3>
                         <p>● 线上领券，周边门店消费</p>
                         <p>● 门店领券，在家线上消费</p>
                         <p>● 线上下单，最近门店配送</p>
                         <p>● 线上下单，选择门店自提</p>
                    </div>
                    <div class="solItem">
                        <div class="icon"></div>
                        <h3>全渠道运营与数字营销 </h3>
                         <p>● 线上线下全方位渠道运营</p>
                         <p>● 针对客户个性化需求实现精准营销</p>
                         <p>● 以社交为核心的建立全渠道流量池</p>
                         <p>● 通过营销自动化找出优质商机及客户</p>
                    </div>
                    <div class="solItem">
                        <div class="icon"></div>
                        <h3>数字化业务孵化</h3>
                         <p>● 数字化转型愿景和顶层设计蓝图</p>
                         <p>● 企业开展数字化创新的业务机会分析</p>
                         <p>● 全新数字化业务数字化重新定义未来</p>
                    </div>
                    <div class="solItem">
                        <div class="icon"></div>
                        <h3>商业环境大数据分析</h3>
                         <p>● 大数据选址，为成功开店甄选好基因</p>
                         <p>● 360度商圈大数据分析，实现战略布局</p>
                         <p>● 门店大数据分析，助力经营决策分析</p>
                    </div>
                    <div class="solItem">
                        <div class="icon"></div>
                        <h3>舆情监控与品牌监控</h3>
                         <p>● 用户网络舆情监测和新闻专题跟踪</p>
                         <p>● 全自动处理、分析与挖掘，智能情报</p>
                         <p>● 洞察舆情、品牌大数据驱动产业智能</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="zhuanxing">
            <div class="centerBox">
                <h3>主要解决方案</h3>
                <p>
                    <span>|</span>
                    <span>|</span>
                </p>
                <p>
                    <span>|</span>
                    <span>|</span>
                </p>
            </div>
            <div class="textHead">
                <h3>企业数字化转型</h3>
                <p>智能化运营，数字化创新</p>
            </div>
            <div class="zhuBox">
                <div class="content">
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_xssc.png" alt=""><p>打造统一的线上商城</p></div>
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yth.png" alt=""><p>打造线上线下一体化模式</p></div>
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_nbgl.png" alt=""><p>以数字化运营驱动内部管理</p></div>
                </div>
            </div>
        </div>
        <div class="analysis">
            <div class="textHead">
                <h3>商业环境大数据分析</h3>
                <p>将大数据整合到企业运营与战略中，提高大数据环境下的商业竞争力</p>
            </div>
            <div class="content">
                <div class="anabox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_sdxp.png" alt="">
                    <p>商店选品</p>
                </div>
                <div class="anabox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_xdxz.png" alt="">
                    <p>商店选品</p>
                </div>
                <div class="anabox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_sczs.png" alt="">
                    <p>商店选品</p>
                </div>
                <div class="anabox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_sptz.png" alt="">
                    <p>商店选品</p>
                </div>
            </div>
        </div>
        <div class="monitor">
            <div class="textHead">
                <h3>舆情监控与品牌监控</h3>
                <p>通过对互联网海量信息自动获取、自动分类聚类、主题检测、专题聚焦<br>实现用户的网络舆论监测、新闻专题追踪、品牌监控等信息需求</p>
            </div>
            <div class="content">
                <div class="monBox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_dsjk.png" alt="">
                    <p>全维度结构化文本大数据库</p>
                </div>
                <div class="monBox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_qlxyy.png" alt="">
                    <p>全类型数据处理、分析、计算机应用</p>
                </div>
                <div class="monBox">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_hx.png" alt="">
                    <p>以客户服务、信息数据为核心</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            scrollTop: 0,// 滚动条的高度
        }
    },
    mounted(){
        this.$refs.topBox.addEventListener('scroll',this.Scroll,true)
    },
    methods: {
    // 滚动事件,绑定到元素div块
    // 如果不绑定到元素上，则只能监听页面滚动
        Scroll(){
            // window.console.log(this.$refs.topBox.scrollTop)
            this.scrollTop = this.$refs.topBox.scrollTop
            // return this.$refs.topBox.scrollTop
        }
    },
    computed: {
        bgColorCom:function(){
            // let top = this.Scroll()
            let bgColor = '#DCDCDC'
            if(this.scrollTop > 0){
                bgColor = '#DCDCDC'
            }
            if(this.scrollTop > 790){
                bgColor = '#018CF4'
            }
            if(this.scrollTop > 1580){
                bgColor = '#222'
            }
            return bgColor
        }
    },
    beforeDestroy() {
        this.$refs.topBox.removeEventListener('scroll', this.Scroll)
    },
    // destroyed () {
    //     // 离开该页面需要移除这个监听的事件，不然会报错
    //     this.$refs.topBox.removeEventListener('scroll', this.Scroll)
    //     // window.delete.this.$refs.topBox.addEventListener('scroll',this.Scroll,false)
    // }
}
</script>

<style lang="scss" scoped>
    .chaCon{
        .banner{
            width: 100%;
            height: 47.5rem;
            background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_banner_szhzx.png) no-repeat center center;
            background-size: 100% 100%;
        }
        .content{
            width: 75rem;
            margin: auto;
        }
        .textHead{
            height: 273px;
            padding-top: 119px;
            box-sizing: border-box;
            h3{
                font-size: 42px;
                color: #333;
                line-height: 42px;
                margin-bottom: 27px;
            }
            p{
                font-size: 22px;
                line-height: 22px;
                color: #666;
            }
        }
        .achieve{
            width: 100%;
            overflow-x: hidden;
            .topBox{
            height: 49.375rem;
            // display: flex;
            overflow: scroll;
            overflow-x: hidden;
            width: 102%;
            .rightBoxBtm{
                height: 49.375rem;
                width: 100%;
                background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_szhzx.png) no-repeat center center;
                background-size: 100% 100%;
                position: relative;
                color: #fff;
                padding-left: 25%;
                box-sizing: border-box;
                .btmItem{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    text-align: left;
                    .rightIcon{
                        width: 3.75rem;
                        height: 3.75rem;
                        background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_szhzx.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;
                        margin-bottom: 2.625rem;
                    }
                    .rightText{
                        height: 2.1875rem;
                        line-height: 2.1875rem;
                        box-sizing: border-box;
                        font-size: 2.1875rem;
                        margin-bottom: 2.3125rem;
                        text-align: left;
                    }
                    .rightBottom{
                        width: 3.5rem;
                        border-bottom: .1875rem solid #fff;
                        margin-bottom: 2.3125rem;
                    }
                        .rightBottomText{
                            font-size: 1.25rem;
                        }
                }
            }
            .topHead{
                display: flex;
                width: 100%;
                .traLeft{
                    width: 50%;
                    img{
                        display:block;
                        width: 100%;
                        height: 49.375rem;
                    }
                }
            .traRight{
                    width: 50%;

                    .rightBox{
                        width: 100%;
                        height: 49.375rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        background: #DCDCDC;
                        .rightIcon{
                            width: 3.75rem;
                            height: 3.75rem;
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_zh.png);
                            background-repeat: no-repeat;
                            background-size: 100% 100%;
                            background-position: center center;
                            margin-bottom: 2.625rem;
                        }
                        .rightText{
                            height: 2.1875rem;
                            line-height: 2.1875rem;
                            box-sizing: border-box;
                            font-size: 2.1875rem;
                            margin-bottom: 2.3125rem;
                        }
                        .rightBottom{
                            width: 3.5rem;
                            border-bottom: .1875rem solid #222;
                            margin-bottom: 2.3125rem;
                        }
                        .rightBottomText{
                            font-size: 1.25rem;
                        }
                    }
                    .rightBox:nth-child(2){
                        background: #018CF4;
                            color: #fff;
                        .rightIcon{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_rh.png);
                        }
                        .rightBottom{
                            border-bottom: .1875rem solid #fff;
                        }
                    }
                    .rightBox:nth-child(3){
                        background: #222;
                            color: #fff;
                        .rightIcon{
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/icon_qd.png);
                        }
                        .rightBottom{
                            border-bottom: .1875rem solid #fff;
                        }
                    }
                }
            }
            }
        }
        .solve{
            width: 100%;
            height: 74.6875rem;
            background: #F2F2F2;
            .content{
                .solCon{
                    display: flex;
                    flex-wrap: wrap;
                    .solItem{
                        width: 23.375rem;
                        height: 22.1875rem;
                        background: #fff;
                        padding-top: 3.75rem;
                        .icon{
                            display: block;
                            margin: auto;
                            width: 4.0625rem;
                            height: 4.0625rem;
                            margin-bottom: 1.75rem;
                            background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/szhzx_icon.png);
                            background-repeat: no-repeat;
                            background-position: -2.0625rem -2.0625rem;
                        }
                        h3{
                            font-size: 1.25rem;
                            font-weight: bold;
                            line-height: 1.25rem;
                            margin-bottom: 2.4375rem;
                        }
                        p{
                            width: 18.375rem;
                            margin: auto;
                            font-size: .9375rem;
                            line-height: 2em;
                            text-align: left;
                            text-indent: 2em;
                        }
                    }
                    .solItem:nth-child(2){
                        .icon{
                            background-position: -10.1875rem -2.0625rem;
                        }
                    }
                    .solItem:nth-child(3){
                        .icon{
                            background-position: -18.3125rem -2.0625rem;
                        }
                    }
                    .solItem:nth-child(4){
                        .icon{
                            background-position: -2.0625rem -10.1875rem;
                        }
                    }
                    .solItem:nth-child(5){
                        .icon{
                            background-position: -10.1875rem -10.1875rem;
                        }
                    }
                    .solItem:nth-child(6){
                        .icon{
                            background-position: -18.3125rem -10.1875rem;
                        }
                    }
                    .solItem:nth-child(-n+3){
                        margin-bottom: 2.5rem;
                    }
                    .solItem:nth-child(2),div:nth-child(5){
                        margin: 0 2.4375rem;
                    }
                }
            }
        }
        .zhuanxing{
            width: 100%;
            .centerBox{
                width: 100%;
                height: 18.75rem;
                background: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zyjjfa.png) no-repeat center center;
                background-size: 100% 100%;
                color: #fff;
                padding-top: 7.0625rem;
                box-sizing: border-box;
                h3{
                    font-size: 2.625rem;
                    line-height: 2.625rem;
                    margin-bottom: 2.9375rem;
                }
                p{
                    font-size: 1.375rem;
                    width: 1.75rem;
                    height: .9375rem;
                    line-height: 1.4375rem;
                    margin: auto;
                    display: flex;
                    justify-content: space-between;
                    span:first-child{
                        transform: rotate(-45deg)
                    }
                    span:last-child{
                        transform: rotate(45deg)
                    }
                }
            }
            .zhuBox{
                width: 100%;
                margin-bottom: 10.5rem;
                .content{
                    display: flex;
                    justify-content: space-between;
                    div{
                        width: 23.3125rem;
                        height: 20.5rem;
                        box-shadow: 0 0 .3125rem #ccc;
                        box-sizing: border-box;
                        img{
                            display: block;
                            width: 100%;
                            height: 14.0625rem;
                            margin-bottom: 2.3125rem;
                        }
                        p{
                            font-size: 1.375rem;
                            font-weight: bold;
                            line-height: 1.5rem;
                            color: #666;
                        }
                    }
                }
            }
        }
        .analysis{
            background: #F2F2F2;
            width: 100%;
            padding-bottom: 10.4375rem;
            .content{
                display: flex;
                justify-content: space-between;
                .anabox{
                    width: 15.5rem;
                    img{
                        display: block;
                        width: 15.5rem;
                        height: 15.5rem;
                        margin-bottom: 1.9375rem;
                    }
                    p{
                        font-size: 1.0625rem;
                        color: #333;
                        line-height: 1.0625rem;
                    }
                }
            }
        }
        .monitor{
            width: 100%;
            .textHead{
                p{
                    height: 4.375rem;
                    line-height: 2.1875rem;
                }
                margin-bottom: 3.625rem;
            }
            .content{
                display: flex;
                justify-content: space-between;
                margin-bottom: 10.125rem;
                .monBox{
                    img{
                        height: 15.625rem;
                        width: 23.3125rem;
                        display: block;
                        margin-bottom: 1.1875rem;
                    }
                    p{
                        font-size: 1.25rem;
                        color: #666;
                        line-height: 1.25rem;
                    }
                }
            }
        }
    }
</style>